// Auto-generated — do not edit
export const APP_VERSION     = '1.0';
export const BUILD_TIMESTAMP = '2026-03-10T19:18:05.044Z';
